import React, { useState, useEffect } from "react";
import { View, Linking } from "react-native";
import { CreateResponsiveStyle, DEVICE_SIZES } from "rn-responsive-styles";
import DashboardComponent from "../SubComponents/Dashboard/DashboardComponent";
import Header from "../common/Header";
import AsyncStorageFunc from "../utilities/asyncStorage";
import { getUserDetails, logout, getUserProfileImage,getPoolAccountdetail,getAllVehiclesListApi,getAllNpciClosedVehicles,getAllKyvPendingVehicles} from "../api/apiManager";
import Loader from "./../common/Loader";
import ModalAlertForTwoButtons from "../common/ModalAlertForTwoButtons";
import { get } from "lodash";
import Sidebar from "../common/Sidebar";
import MobileHeader from "../common/MobileHeader";
import TabHeader from "../common/TabHeader";
import { useLogin } from "../context/loginProvider";
import CImage from "../common/CImage";
import { useApiContext } from "../api/ApiContext";
import { isEmpty } from "lodash";
import CWelcomeModalTagClosure from "../common/CWelcomeModalTagClosure"
import { getConfigurations } from "../api/serviceRequest";
import CWelcomeModalKyvPending from "../common/CWelcomeModalKyvPending.web";


export default function Dashboard(props) {
  const styles = useStyles();
  const [loading, setLoading] = useState(false);
  const [isLogout, setIsLogout] = useState(false);
  const [allVehiclesBalance, setAllVehiclesBalance] = useState();
  const [poolBalance, setPoolBalance] = useState();
  const [ vehicleDetails, setVehicleDetails ] = useState();
  const [ npciClosedVehicleList, setNpciClosedVehicleList] = useState([]);
  const [isShowSidebar, setIsShowSidebar] = useState(false);
  const [npciModal, setNpciModal] = useState(false);
  const [kyvModal,setKyvModal] = useState(false)
  const [ kyvPendingVehicleList, setKyvPendingVehicleList] = useState([]);
  const [ vehicleList, setVehicleList] = useState([]);
  const { isLoggedIn, setIsLoggedIn } = useLogin();
  const {  } = useApiContext();

  const onNpciTagCloseModal = () =>{
    setNpciModal(false)
  }
  const onKyvPendingModal = () =>{
    setKyvModal(false)
  }

  const getPoolAccountDtls = () => {
    if (!poolBalance || poolBalance.length === 0) {
      setLoading(true);
      // console.log(poolBalance, "poolBalance==>")
      getPoolAccountdetail()
        .then((res) => {
          setLoading(false);
          setPoolBalance(res?.accountBal || 0);
          AsyncStorageFunc.storeData("POOL_ACNT_NBR", res?.accountNo || 0);
        })
        .catch((err) => {
          setLoading(false);
          if (err?.message == "Invalid token specified") {
            setIsLoggedIn(false)
     } });
    } };

    const geAllVehicle = () => {
      if (isEmpty(vehicleDetails) || vehicleDetails === 0) {
        setLoading(true);  
        getAllVehiclesListApi()
          .then((res) => {
            // console.log(res,'All veh Res')
            var negatives = [];
            var sum = 0;
            for (var i = 0; i < res.length; i++) {
              if (res[i].fastagBalance < 0 || res[i].fastagBalance > 0) {
                sum += res[i].fastagBalance;
                console.log(sum,'sum1')
              } 
            }
            setVehicleList(res)
            setAllVehiclesBalance(sum);
            setLoading(false);
            if (res?.length) {
              setVehicleDetails(res[0])
            };
          })
          .catch((err) => {
            setLoading(false);
            if (err?.message == "Invalid token specified") {
              setIsLoggedIn(false)
            } }); };
    }
    let totalBalance = (parseFloat(poolBalance) + parseFloat(allVehiclesBalance)).toFixed(2) 

  const getProfileDetails = () => {
    setLoading(true);
    getUserDetails()
      .then((res) => {
        global.showTripInsurance = res?.insuranceAllowed;
        global.profileDetails = res;
        global.mobileNo = get(res, "mobileNo", "");
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        if (err?.message == "Invalid token specified") {
          setIsLoggedIn(false);
        }
      });
  };

  const getProfileImage = () => {
    getUserProfileImage()
      .then((res) => {
        global.userProfileImg = res;
      })
      .catch((err) => {
        if (err?.message == "Invalid token specified") {
          setIsLoggedIn(false);
        }
      });
  };
  const loadDefaultConfig = () => {
    
    getConfigurations().then((res)=>{
      if(res.statusCode == 200) {

        let SINGLE_FILE_SIZE_LIMIT = res?.data.filter(val => val.key == "SINGLE_FILE_SIZE_LIMIT")
        let KYC_SINGLE_FILE_SIZE_LIMIT = res?.data.filter(val => val.key == "KYC_FILE_SIZE_LIMIT")

        let maxFileSize = SINGLE_FILE_SIZE_LIMIT[0].value/1024
        let kycMaxFileSize = KYC_SINGLE_FILE_SIZE_LIMIT[0].value/1024 
        
        global.maxUploadFileSizeInMB = maxFileSize
        global.kycMaxUploadFileSizeInMB = kycMaxFileSize
        const tripClaimContactInfoObj = res?.data.find((configItem) => configItem.key == "tripClaimContactInfo");
        const tripIsnpReferenceNo = res?.data.find((configItem) => configItem.key == "trip_isnp_reference_no");
        const ifscRegex = res?.data.find((configItem) => configItem.key == "ifscCodeRegex");
        const welcomeConfigEventsObj =  res?.data.find((configItem) => configItem.key == "welcome-config-key");
        const ccavenueAccessCode =res?.data.find((configItem) => configItem.key == "ccavenue_access_code");
        const CC_AVENUE_URL =res?.data.find((configItem) => configItem.key == "CC_AVENUE_URL");
        const AUTO_RECHARGE_APPLY_LINK =res?.data.find((configItem) => configItem.key == " AUTO_RECHARGE_APPLY_LINK");
        const CC_EMAIL = res?.data.find((configItem) => configItem.key == "CC_EMAIL");
        const CC_CONTACT  = res?.data.find((configItem) => configItem.key == "CC_CONTACT");

        if (CC_EMAIL) {
          global.CC_EMAIL = CC_EMAIL.value;
        }
        if (CC_CONTACT) {
          global.CC_CONTACT = CC_CONTACT.value;
        }
        if (CC_AVENUE_URL) {
          global.CC_AVENUE_URL = CC_AVENUE_URL.value;
        }
        if (AUTO_RECHARGE_APPLY_LINK) {
          global.AUTO_RECHARGE_APPLY_LINK = AUTO_RECHARGE_APPLY_LINK.value;
        }
      if (ccavenueAccessCode) {
        global.ccavenueAccessCode = ccavenueAccessCode.value;
      }
      if (tripClaimContactInfoObj) {
        global.tripClaimContactInfo = tripClaimContactInfoObj.value;
      }
      if (tripIsnpReferenceNo) {
        global.tripIsnpReferenceNo = tripIsnpReferenceNo.value;
      }
      if (ifscRegex) {
        global.ifscRegex = ifscRegex.value;
      }
      if (welcomeConfigEventsObj && welcomeConfigEventsObj.value) {
        global.welcomeConfigEvents = welcomeConfigEventsObj.value.split(',');
      }

      }
    }).catch((err)=>{
      global.maxUploadFileSizeInMB = 2
      global.kycMaxUploadFileSizeInMB = 1
    })
}

  const getAllNpciClosedVehiclesList = ()=>{
      setLoading(true);  
      getAllNpciClosedVehicles()
        .then((res) => {
          setLoading(false);
          if (res?.length) {
            setNpciModal(true)
            setNpciClosedVehicleList(res)
          }else{
            getAllKyvPendingVehicleList()
          };
        })
        .catch((err) => {
          setLoading(false); }); 
  }
  const getAllKyvPendingVehicleList = ()=>{
    setLoading(true);  
    getAllKyvPendingVehicles()
      .then((res) => {
        setLoading(false);
        if (res?.length) {
          setKyvModal(true)
          setKyvPendingVehicleList(res)
        };
      })
      .catch((err) => {
        setLoading(false); }); 
}

  useEffect(() => {
    if (history.pushState) {
      history.pushState(null, document.title, location.href);
      window.addEventListener("popstate", function (event) {
        history.pushState(null, document.title, location.href);
      });
    }
    getProfileImage();
    getPoolAccountDtls()
    geAllVehicle()
    loadDefaultConfig()
    getProfileDetails();
    getAllNpciClosedVehiclesList()
    // getAllKyvPendingVehicleList()
  }, []);

 
  const userLogout = () => {
    setLoading(true);
    let req = {
      userId: global.userId,
    };
    logout(req)
      .then(() => {
        setTimeout(() => {
          setLoading(false);
          AsyncStorageFunc.deleteData("TOKEN").then((tokenRes) => {
            props.navigation.navigate("Login");
            window.location.reload(true);
          });
        }, 1000);
      })
      .catch();
  };
  return (
    <View style={styles.container}>
      <Header navigation={props.navigation} />
      <MobileHeader
        isShowSidebar={setIsShowSidebar}
        isHeaderView
        isLogout={setIsLogout}
      />
      <TabHeader />
      <View style={styles.bgViewStyle}>
        <View style={styles.fullContainer}>
          {!isShowSidebar && <Sidebar navigation={props.navigation} />}
          <DashboardComponent navigation={props.navigation} totalBalance={totalBalance} isShowSidebar={!isShowSidebar} />
        </View>
      </View>
      <View style={styles.footerHelper}>
        <CImage.NpciImage></CImage.NpciImage>
      </View>
      {npciModal && <CWelcomeModalTagClosure vehicleList = {npciClosedVehicleList } onCloseModal={onNpciTagCloseModal} />}
      {kyvModal && <CWelcomeModalKyvPending vehicleList = {vehicleList } onCloseModal={onKyvPendingModal} />}
      {loading && <Loader />}
      {isLogout ? (
        <View style={styles.overlayViewStyle}>
          <ModalAlertForTwoButtons
            title={"Logout"}
            message={"Are you sure, you want to logout ?"}
            actionButton1={"Cancel"}
            actionButton2={"Logout"}
            onPressActionButton1={() => {
              setIsLogout(false);
            }}
            onPressActionButton2={() => {
              setIsLogout(false);
              userLogout();
            }}
            backgroundColor={"#bd2d37"}
            color={"#ffffff"}
          />
        </View>
      ) : null}
    </View>
  );
}

const useStyles = CreateResponsiveStyle(
  {
    container: {
      backgroundColor: "#f2f4f5",
      height: "100vh",
    },
    overlayViewStyle: {
      position: "absolute",
      zIndex: 9999,
      backgroundColor: "rgba(52,52,52,0.9)",
      width: "100%",
      height: "100%",
      top: 0,
      left: 0,
      borderRadius: 15,
    },

    fullContainer: {
      flexDirection: "row",
      marginTop: 40,
      maxWidth: 1200,
      width: "100%",
    },
    bgViewStyle: {
      backgroundImage:
        "linear-gradient(#1D1D1D, #1D1D1D 50%, #F2F4F5 50%, #F2F4F5 100%)",
      width: "100%",
      flexDirection: "column",
      alignItems: "center",
      paddingLeft: 25,
      paddingRight: 25,
    },
    mainContentViewStyle: {
      flexDirection: "column",
      width: "100%",
      maxWidth: 1200,
      minHeight: 1050,
      height: "100%",
      paddingTop: 50,
    },

    footerHelper: {
      display: "flex",
      flexDirection: "row",
      width: "100%",
      alignItems: "center",
      justifyContent: "space-evenly",
      padding: 25,
      backgroundColor: "#f2f4f5",
    },
  },

  {
    [DEVICE_SIZES.MD]: {
      container: {
        height: 1700,
        overflow: "scroll",
      },
      fullContainer: {
        maxWidth: 999,
      },
      footerHelper: {
        display: "none",
      },
    },
    [DEVICE_SIZES.SM]: {
      footerHelper: {
        display: "none",
      },
    },
    [DEVICE_SIZES.XS]: {
      container: {
        height: 1100,
        width: "100%",
      },
      fullContainer: {
        flexDirection: "row",
        marginTop: 40,
        maxWidth: 1200,
        width: "100%",
        justifyContent: "center",
      },
      footerHelper: {
        display: "none",
      },
      bgViewStyle: {
        backgroundImage:
          "linear-gradient(#1D1D1D, #1D1D1D 50%, #F2F4F5 50%, #F2F4F5 100%)",
        width: "100%",
        height: "100%",
        flexDirection: "column",
        alignItems: "center",
        paddingLeft: 15,
        paddingRight: 15,
      },
    },
  }
);
